import { Collection, RefSerializer } from "@tblabs/truffle";
import { Human } from "../../../Models/Human";
import { Order } from "../../../Models/Order";
import { RawHuman } from "../../../Models/RawHuman";
import { RawOrder } from "../../../Models/RawOrder";
import { StepType } from "../../../Steps/Step/StepType";
import { StepFactory } from "../../StepFactory";
import { OrderMeta } from "../../../Models/OrderMeta";
import { Converter } from "@tblabs/storage";


export class OrderConverter extends Converter<RawOrder, Order>
{
    constructor(private _stepFactory: StepFactory)
    {
        super();
    }

    public ConvertFromRaw(raw: RawOrder): Order
    {
        const order = new Order();
        order.Id = this.GetString(raw.Id);

        order.Steps = this.GetCollection(raw.Steps, x => this._stepFactory.Create(x.Type as StepType, x.Data));

        const people = this.GetCollection<RawHuman, Human>(raw.People, x => new Human(x));
        order.People.Load(...people.Items);

        order.Meta = new OrderMeta(raw.Meta);

        order.Notes.Customer.value = this.GetString(raw.Notes?.Customer);
        order.Notes.Public.value = this.GetString(raw.Notes?.Public);
        order.Notes.Private.value = this.GetString(raw.Notes?.Private);

        order.SelfSetup();

        return order;
    }

    public ConvertToRaw(order: Order): RawOrder
    {
        return RefSerializer.Flatenize({
            Id: order.Id.toUpperCase(),
            Steps: order.Steps.Items.map(x => ({ Type: x.Type, Data: x.Data })),
            People: order.People.Items,
            Meta: order.Meta,
            Notes: {
                Customer: order.Notes.Customer.value,
                Public: order.Notes.Public.value,
                Private: order.Notes.Private.value
            }
        });
    }

    public GetCollection<R, T>(value: R[], creator: (raw: R) => T): Collection<T>
    {
        const items = value?.map(x => creator(x));
        
        return new Collection<T>(items);
    }
}
